var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cfs-wrap" }, [
    _c("aside", { staticClass: "cfs-sidebar" }, [
      _c(
        "div",
        {
          staticClass: "cfs-sidebar-header",
          on: {
            click: function($event) {
              _vm.sidebarOpen = !_vm.sidebarOpen
            }
          }
        },
        [
          _vm._v("\n      Settings\n      "),
          _c("i", {
            class: _vm.sidebarOpen ? "el-icon-arrow-up" : "el-icon-arrow-down"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sidebarOpen,
              expression: "sidebarOpen"
            }
          ],
          staticClass: "cfs-nav"
        },
        _vm._l(_vm.navSections, function(sec) {
          return _c("li", { key: sec.id }, [
            _c(
              "a",
              {
                class: { active: _vm.activeSection === sec.id },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.goToSection(sec.id)
                  }
                }
              },
              [_vm._v(_vm._s(sec.label))]
            )
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "content",
        staticClass: "cfs-content",
        on: { scroll: _vm.onContentScroll }
      },
      [
        _c(
          "section",
          { staticClass: "cfs-section", attrs: { id: "confirmation" } },
          [
            _c("h2", { staticClass: "cfs-section-title" }, [
              _vm._v("Confirmation Settings")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cfs-field" }, [
              _c(
                "label",
                { staticClass: "cfs-label" },
                [
                  _vm._v("\n          Confirmation Type\n          "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          "Choose what happens after a successful submission",
                        placement: "top"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info cfs-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cfs-radio-group" },
                _vm._l(_vm.redirects_to, function(opt) {
                  return _c(
                    "label",
                    {
                      key: opt.value,
                      staticClass: "cfs-radio-pill",
                      class: { active: _vm.settings.redirect_to === opt.value }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.settings.redirect_to,
                            expression: "settings.redirect_to"
                          }
                        ],
                        attrs: { type: "radio" },
                        domProps: {
                          value: opt.value,
                          checked: _vm._q(_vm.settings.redirect_to, opt.value)
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.settings,
                              "redirect_to",
                              opt.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "cfs-radio-dot" }),
                      _vm._v(
                        "\n            " + _vm._s(opt.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.settings.redirect_to === "same",
                    expression: "settings.redirect_to === 'same'"
                  }
                ],
                staticClass: "cfs-field"
              },
              [
                _c(
                  "label",
                  { staticClass: "cfs-label" },
                  [
                    _vm._v("\n          Message to show\n          "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            "This message is shown to the user after a successful submission",
                          placement: "top"
                        }
                      },
                      [_c("i", { staticClass: "el-icon-info cfs-info" })]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("wp_editor", {
                  attrs: { value: _vm.settings.message },
                  on: {
                    "content-changed": function(val) {
                      return _vm.updateSetting("message", val)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.settings.redirect_to === "page",
                    expression: "settings.redirect_to === 'page'"
                  }
                ],
                staticClass: "cfs-field"
              },
              [
                _c("label", { staticClass: "cfs-label" }, [_vm._v("Page")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "Select a page" },
                    model: {
                      value: _vm.settings.page_id,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "page_id", $$v)
                      },
                      expression: "settings.page_id"
                    }
                  },
                  _vm._l(_vm.settings.pages, function(page, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: index, value: page }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.settings.redirect_to === "url",
                    expression: "settings.redirect_to === 'url'"
                  }
                ],
                staticClass: "cfs-field"
              },
              [
                _c("label", { staticClass: "cfs-label" }, [
                  _vm._v("Custom URL")
                ]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "url",
                    placeholder: "https://example.com/thank-you"
                  },
                  model: {
                    value: _vm.settings.url,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "url", $$v)
                    },
                    expression: "settings.url"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cfs-field" }, [
              _c(
                "label",
                { staticClass: "cfs-label" },
                [
                  _vm._v("\n          After Form Submission\n          "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          "Choose whether to hide or reset the form after submission",
                        placement: "top"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info cfs-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cfs-radio-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "cfs-radio-pill",
                    class: { active: _vm.settings.after_submit !== "reset" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settings.after_submit,
                          expression: "settings.after_submit"
                        }
                      ],
                      attrs: { type: "radio", value: "hide" },
                      domProps: {
                        checked: _vm._q(_vm.settings.after_submit, "hide")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.settings, "after_submit", "hide")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "cfs-radio-dot" }),
                    _vm._v("\n            Hide Form\n          ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "cfs-radio-pill",
                    class: { active: _vm.settings.after_submit === "reset" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settings.after_submit,
                          expression: "settings.after_submit"
                        }
                      ],
                      attrs: { type: "radio", value: "reset" },
                      domProps: {
                        checked: _vm._q(_vm.settings.after_submit, "reset")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.settings, "after_submit", "reset")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "cfs-radio-dot" }),
                    _vm._v("\n            Reset Form\n          ")
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cfs-field" },
              [
                _c("label", { staticClass: "cfs-label" }, [
                  _vm._v("Submit Button Text")
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { "max-width": "320px" },
                  attrs: { type: "text" },
                  model: {
                    value: _vm.settings.submit_text,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "submit_text", $$v)
                    },
                    expression: "settings.submit_text"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("section", { staticClass: "cfs-section", attrs: { id: "layout" } }, [
          _c("h2", { staticClass: "cfs-section-title" }, [
            _vm._v("Form Layout")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cfs-field" }, [
            _c("label", { staticClass: "cfs-label" }, [
              _vm._v("Label Position")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cfs-radio-group" },
              _vm._l(_vm.label_positions, function(pos) {
                return _c(
                  "label",
                  {
                    key: pos.value,
                    staticClass: "cfs-radio-pill",
                    class: { active: _vm.settings.label_position === pos.value }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settings.label_position,
                          expression: "settings.label_position"
                        }
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        value: pos.value,
                        checked: _vm._q(_vm.settings.label_position, pos.value)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(
                            _vm.settings,
                            "label_position",
                            pos.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "cfs-radio-dot" }),
                    _vm._v(
                      "\n            " + _vm._s(pos.label) + "\n          "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("p", { staticClass: "cfs-description" }, [
              _vm._v("Where the labels of the form should display.")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cfs-field" }, [
            _c("label", { staticClass: "cfs-label" }, [
              _vm._v("Use Theme CSS")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cfs-radio-group" }, [
              _c(
                "label",
                {
                  staticClass: "cfs-radio-pill",
                  class: {
                    active:
                      _vm.settings.use_theme_css === "contactum-theme-style"
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.settings.use_theme_css,
                        expression: "settings.use_theme_css"
                      }
                    ],
                    attrs: { type: "radio", value: "contactum-theme-style" },
                    domProps: {
                      checked: _vm._q(
                        _vm.settings.use_theme_css,
                        "contactum-theme-style"
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.settings,
                          "use_theme_css",
                          "contactum-theme-style"
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "cfs-radio-dot" }),
                  _vm._v("\n            Yes\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "cfs-radio-pill",
                  class: {
                    active: _vm.settings.use_theme_css === "contactum-style"
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.settings.use_theme_css,
                        expression: "settings.use_theme_css"
                      }
                    ],
                    attrs: { type: "radio", value: "contactum-style" },
                    domProps: {
                      checked: _vm._q(
                        _vm.settings.use_theme_css,
                        "contactum-style"
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.settings,
                          "use_theme_css",
                          "contactum-style"
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "cfs-radio-dot" }),
                  _vm._v("\n            No\n          ")
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "cfs-section", attrs: { id: "scheduling" } },
          [
            _c("h2", { staticClass: "cfs-section-title" }, [
              _vm._v("Scheduling & Restrictions")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cfs-field" }, [
              _c("label", { staticClass: "cfs-label" }, [
                _vm._v("Schedule Form")
              ]),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "cfs-toggle" },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.settings.schedule_form,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "schedule_form", $$v)
                      },
                      expression: "settings.schedule_form"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Schedule form for a time period")])
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "cfs-description" }, [
                _vm._v("Restrict when the form accepts submissions.")
              ])
            ]),
            _vm._v(" "),
            _vm.settings.schedule_form
              ? [
                  _c("div", { staticClass: "cfs-field" }, [
                    _c("label", { staticClass: "cfs-label" }, [
                      _vm._v("Schedule Period")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cfs-date-row" },
                      [
                        _c("span", { staticClass: "cfs-date-label" }, [
                          _vm._v("From")
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          attrs: { type: "date", placeholder: "Start date" },
                          model: {
                            value: _vm.settings.schedule_start,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "schedule_start", $$v)
                            },
                            expression: "settings.schedule_start"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "cfs-date-label" }, [
                          _vm._v("To")
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          attrs: { type: "date", placeholder: "End date" },
                          model: {
                            value: _vm.settings.schedule_end,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "schedule_end", $$v)
                            },
                            expression: "settings.schedule_end"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cfs-field" },
                    [
                      _c("label", { staticClass: "cfs-label" }, [
                        _vm._v("Form Pending Message")
                      ]),
                      _vm._v(" "),
                      _c("wp_editor", {
                        attrs: { value: _vm.settings.sc_pending_message },
                        on: {
                          "content-changed": function(val) {
                            return _vm.updateSetting("sc_pending_message", val)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cfs-field" },
                    [
                      _c("label", { staticClass: "cfs-label" }, [
                        _vm._v("Form Expired Message")
                      ]),
                      _vm._v(" "),
                      _c("wp_editor", {
                        attrs: { value: _vm.settings.sc_expired_message },
                        on: {
                          "content-changed": function(val) {
                            return _vm.updateSetting("sc_expired_message", val)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "cfs-field" }, [
              _c("label", { staticClass: "cfs-label" }, [
                _vm._v("Require Login")
              ]),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "cfs-toggle" },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.settings.require_login,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "require_login", $$v)
                      },
                      expression: "settings.require_login"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Require user to be logged in to submit")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.settings.require_login
              ? _c(
                  "div",
                  { staticClass: "cfs-field" },
                  [
                    _c("label", { staticClass: "cfs-label" }, [
                      _vm._v("Require Login Message")
                    ]),
                    _vm._v(" "),
                    _c("wp_editor", {
                      attrs: { value: _vm.settings.req_login_message },
                      on: {
                        "content-changed": function(val) {
                          return _vm.updateSetting("req_login_message", val)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "cfs-field" }, [
              _c("label", { staticClass: "cfs-label" }, [
                _vm._v("Limit Entries")
              ]),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "cfs-toggle" },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.settings.limit_entries,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "limit_entries", $$v)
                      },
                      expression: "settings.limit_entries"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enable form entry limit")])
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "cfs-description" }, [
                _vm._v("Limit the number of entries allowed for this form.")
              ])
            ]),
            _vm._v(" "),
            _vm.settings.limit_entries
              ? [
                  _c(
                    "div",
                    { staticClass: "cfs-field" },
                    [
                      _c("label", { staticClass: "cfs-label" }, [
                        _vm._v("Number of Entries")
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { "max-width": "180px" },
                        attrs: { type: "number" },
                        model: {
                          value: _vm.settings.limit_number,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "limit_number", $$v)
                          },
                          expression: "settings.limit_number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cfs-field" },
                    [
                      _c("label", { staticClass: "cfs-label" }, [
                        _vm._v("Limit Reached Message")
                      ]),
                      _vm._v(" "),
                      _c("wp_editor", {
                        attrs: { value: _vm.settings.limit_message },
                        on: {
                          "content-changed": function(val) {
                            return _vm.updateSetting("limit_message", val)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "cfs-section", attrs: { id: "custom-css-js" } },
          [
            _c("h2", { staticClass: "cfs-section-title" }, [
              _vm._v("Custom CSS & JS")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cfs-field" },
              [
                _c("label", { staticClass: "cfs-label" }, [
                  _vm._v("Custom CSS")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "cfs-description" }, [
                  _vm._v("\n          Applies only to this form. Use "),
                  _c("code", [_vm._v("#contactum_form_" + _vm._s(_vm.id))]),
                  _vm._v(" as a selector prefix.\n          Do not include "),
                  _c("code", [_vm._v("<style>")]),
                  _vm._v(" tags.\n        ")
                ]),
                _vm._v(" "),
                _c("AceCSSEditor", {
                  attrs: { mode: "css" },
                  model: {
                    value: _vm.settings.custom_css,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "custom_css", $$v)
                    },
                    expression: "settings.custom_css"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cfs-field" },
              [
                _c("label", { staticClass: "cfs-label" }, [
                  _vm._v("Custom JS")
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("AceJSEditor", {
                  attrs: { mode: "javascript" },
                  model: {
                    value: _vm.settings.custom_js,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "custom_js", $$v)
                    },
                    expression: "settings.custom_js"
                  }
                })
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "cfs-description" }, [
      _vm._v("\n          Selecting "),
      _c("strong", [_vm._v("Yes")]),
      _vm._v(" will use your theme's style for form fields.\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "cfs-description" }, [
      _vm._v("\n          Runs after the form initialises. "),
      _c("code", [_vm._v("$form")]),
      _vm._v(
        " is the jQuery DOM object of the form.\n          Do not include "
      ),
      _c("code", [_vm._v("<script>")]),
      _vm._v(" tags.\n        ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }